import { render } from "./OrgCreationView.vue?vue&type=template&id=22151247"
import script from "./OrgCreationView.vue?vue&type=script&lang=js"
export * from "./OrgCreationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__